import { useQuery } from '@tanstack/react-query';

import { rbacQueries } from '../../api/rbacQueries';

/*
 * Whether the logged-in user may write the office master data: only a
 * global admin may, and it is the real user who is asked, not a role
 * assumed in the sidebar (see `rbacQueries.context`).
 *
 * Anything but a plain yes counts as no — while the answer is still on
 * its way, if it never arrives, or if the backend refuses it. The
 * buttons it governs are disabled then, which is the harmless way
 * round: they would be refused by the backend anyway, and offering
 * them is a promise the app cannot keep.
 */
export function useGlobalAdmin() {
  const { data } = useQuery(rbacQueries.context());

  return data?.globalAdmin === true;
}
